import React from 'react';
import styled from '@emotion/styled';
import { gridSize } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import trustAndSecurity from '../images/trust-and-security.svg';
import Heading from '@atlaskit/heading';

const imgHeight = 92;

const PasswordExpiredContainer = styled.div`
  background: url(${trustAndSecurity}) no-repeat center top;
  background-size: 50% 50%;
  padding-top: ${imgHeight + gridSize() * 8}px;
`;

const Message = styled.p`
  margin: ${gridSize()}px 0;
`;

const Email = styled.p`
  font: ${token('font.heading.small')};
  margin-top: ${gridSize()}px;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
`;
interface Props {
  header?: React.ReactNode;
  children?: React.ReactNode;
  email?: string;
  message?: React.ReactNode;
}

const PasswordExpiredNotice = (props: Props) => {
  const { header, children, email, message } = props;

  return (
    <PasswordExpiredContainer id="password-expired-notice">
      <Heading as="h2" size="xsmall" id="password-expired-header">
        {header}
      </Heading>
      <Message id="password-expired-message">{message}</Message>
      {email && <Email>{email}</Email>}
      {children}
    </PasswordExpiredContainer>
  );
};

export default PasswordExpiredNotice;
